<div class="mb-4 relative">
  <label *ngIf="label" class="block text-sm lg:text-base font-bold" [ngClass]="classList?.['label']">{{ label }}</label>
  <div
    class="relative py-1.5 overflow-hidden wrap px-2"
    [ngClass]="{
      'border-gray-800': !displayError,
      'border rounded-md [&:has(:focus)]:border-yellow-800 hover:border-gray-800 [&:has(:focus)]:border-[1.5px] hover:border-[1.5px] [&:has(:focus)]:-m-[0.5px] hover:-m-[0.5px] border-bottom-none':
        bordered,
      'border-bottom-none': !borderBottom,
      'border-bey-red': displayError
    }">
    <select
      class="w-full outline-0 break-words text-ellipsis"
      [(ngModel)]="value"
      [disabled]="isLoading"
      (blur)="onBlur()">
      <option value="" disabled selected style="font-family: Radikal, sans-serif">{{ placeholder }}</option>
      <option *ngFor="let option of options" [value]="option[bindValue]" style="font-family: Radikal, sans-serif">
        {{ option[bindLabel] }}
      </option>
    </select>
  </div>
  <bey-field-error-message *ngIf="!hideValidationFeedback" [displayError]="displayError" [errorMessage]="errorMessage">
  </bey-field-error-message>
</div>
